/* eslint-disable sort-keys */
import textStyles from "../constants/textStyles";

export default {
    FormLabel: {
        baseStyle: {},
        sizes: {
            default: {}
        },
        variants: {
            default: {
                ...textStyles.p2
            }
        },
        defaultProps: {
            variant: "default"
        },
    }

};

